import * as React from 'react';
import { Component, deps, inject, observer } from '../../lib/component';
import { LayoutContent } from '../layout/content';
import { UserLoginLink } from '../user/login-link';
import { AccountMenu } from './menu';
import { Loading } from '../loading/loading';
import { classes, style } from 'typestyle';
import { percent, px } from 'csx';
import { horizontal } from 'csstips';
import { ContainerQuery } from 'react-container-query';
import {mediaMobileOnly} from '../../theme/media';
import {colorBackgroundAlt, colorWhite} from '../../theme/color';
import MainWrapper from '../main-wrapper';
import {constantMysteriousNarrowAccountLayoutBreakpoint} from "../../theme/constant";
import CheckoutUserPanel from "../checkout-v2/checkout-user-panel";

export interface AccountLayoutProps {
  className?: string;
}

@inject(deps) @observer
export class AccountLayout extends Component<AccountLayoutProps> {
  render() {
    const { user, channel } = this.props.model.user;
    const { firstPaint } = this.props.model.ui;

    return (
      <MainWrapper className={AccountLayout.styles.container}>
        {!user && (
          <LayoutContent innerClassName={AccountLayout.styles.empty}>
            <UserLoginLink firstPaint={firstPaint} noLogo={true} /> to view your account
          </LayoutContent>
        )}
        {user && !channel && (
          <LayoutContent innerClassName={AccountLayout.styles.empty}>
            <Loading />
          </LayoutContent>
        )}
        {user && channel && (
          <ContainerQuery query={AccountLayout.query} children={(params: any) => (
            <LayoutContent innerClassName={classes(AccountLayout.styles.split, params.narrow && AccountLayout.styles.splitNarrow)}>
              <div className={classes(AccountLayout.styles.main, params.narrow && AccountLayout.styles.childNarrow, this.props.className)}>
                <AccountMenu />
                <div className={AccountLayout.styles.inner}>
                  {this.props.children}
                </div>
              </div>
              <div className={classes(AccountLayout.styles.aside, params.narrow && AccountLayout.styles.childNarrow)}>
                <CheckoutUserPanel handleSignIn={() => void 0} floating={false} />
              </div>
            </LayoutContent>
          )} />
        )}
      </MainWrapper>
    )
  }

  static query = {
    narrow: {
      maxWidth: constantMysteriousNarrowAccountLayoutBreakpoint
    }
  }

  static styles = {
    container: style({
      minHeight: percent(100),
      flexGrow: 1,
      $nest: {
        '& h2': {
          wordWrap: 'break-word'
        }
      }
    }),
    empty: style({
      width: percent(100),
      padding: px(80)
    }),
    split: style(
      {
        ...horizontal,
        width: percent(100),
      },
      mediaMobileOnly({
        flexDirection: 'column'
      })
    ),
    splitNarrow: style({
      flexDirection: 'column'
    }),
    inner: style({
      padding: px(20),
    }),
    main: style(
      {
        flex: 2,
        background: colorWhite.toString(),
        height: percent(100),
      },
      mediaMobileOnly({
        width: percent(100),
        height: 'auto',
        flex: 'none'
      })
    ),
    aside: style(
      {
        background: colorBackgroundAlt.toString(),
        position: 'relative',
        flex: 1,
        height: percent(100),
        $nest: {
          '& ul': {
            margin: 0,
            padding: 0,
            listStyle: 'none inside none'
          },
          '& ul li': {
            margin: 0,
            padding: 0,
          }
        }
      },
      mediaMobileOnly({
        width: percent(100),
        height: 'auto',
        flex: 'none'
      })
    ),
    childNarrow: style({
      width: percent(100),
      height: 'auto',
      flex: 'none'
    })
  }
}